<div class="table-responsive">
    <table class="table table-hover table-sm">
        <thead>
        <tr>
            <th *ngFor="let hn of fieldsNames">{{hn}}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="loading">
            <td [attr.colspan]="fieldsEntries.length" class="text-center">
                <i class="fa fa-spin fa-circle-notch" aria-hidden="true"></i>
            </td>
        </tr>
        <tr *ngFor="let entry of selectables|async; let entryIndex = index" (click)="toggleSelection(entryIndex)">
            <ng-template ngFor [ngForOf]="fieldsEntries" let-item let-i="index">
                <td *ngIf="i === 0">
                    <span class="far" [ngClass]="isSelected(entryIndex) ? 'fa-check-square' : 'fa-square' "></span>
                </td>
                <td *ngIf="i > 0">{{entry[item]}}</td>
            </ng-template>
        </tr>
        </tbody>
    </table>
</div>
